<app-auction-announcement class="col-12" [auctionId]="auctionId" [auction]="auctionData">
</app-auction-announcement>

<div class="col-12 manage-lot-wrapper">
  <div class="row" *ngIf="totalLots">
    <div class="col-12">
      <div class="manage-lot-hdg mb-3 mt-0 mt-md-2">
        <h1 class="hdg m-0">Manage Lots ({{ totalLots }} Lots)</h1>
      </div>
    </div>
  </div>

  <div class="row filter-wrap">
    <div class="col-md-6">
      <search-control [placeholder]="'Search by lot # or description'" [initialValue]="searchTerm"
        [classes]="'colored-search-border'" (value)="changeSearchValue($event)">
      </search-control>
    </div>
    <div class="col-md-6 text-right">
      <button class="btn btn-white-border mb-2" type="button" role="button" (click)="savePrices()">
        Save
      </button>

      <button class="btn btn-white-border ml-2 mb-2" type="button" role="button" (click)="downloadCSV()">
        Download Lot Catalog
      </button>

      <button class="btn btn-colored ml-2 mb-2" type="button" role="button" (click)="openAddLotModal(addLotModal)">
        + Add New Lot
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="empty-state-container" *ngIf="totalLots <= 0; else showTable">
        <div class="empty-state-content">
          <img alt="empty" src="../../../../assets/images/empty-state-icon.svg" />
          <h3 class="_heading">No results found</h3>
        </div>
      </div>
      <ng-template #showTable>
        <div class="data-table-wrap w-100">
          <div [ngClass]="{
              'disable-event': this.openingAndReservePriceArray.length > 0
            }">
            <p *ngIf="this.openingAndReservePriceArray.length > 0">
              You left with some changes, save them first please
            </p>
            <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
              (page)="onPageChange($event)" *ngIf="totalLots > pageSize">
            </app-paginator>
          </div>

          <table aria-label="lotsTable" mat-table [dataSource]="
              lotsData
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: pageSize,
                      currentPage: pageNumber,
                      totalItems: totalLots
                    }
            " class="mat-elevation-z8 w-100 table-with-border manage-lots-table">
            <ng-container matColumnDef="lotNo">
              <th scope="col" mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell class="column-1 listing-data-entry table-with-row-header" *matCellDef="let element">
                <span class="td-header">Lot #</span> {{ element?.lotNumber }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lotDescription">
              <th scope="col" mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell #tooltip="matTooltip" matTooltip="{{ element?.description }}"
                class="column-2 listing-data-entry table-with-row-header yellow-bg" *matCellDef="let element">
                <span class="td-header">Lot Description</span>
                {{ element?.description | characterLimit: 50 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="location">
              <th scope="col" mat-header-cell *matHeaderCellDef>Weight</th>
              <td mat-cell *matCellDef="let element" class="column-3 listing-data-entry table-with-row-header">
                <span class="td-header">Location</span> {{ element?.location }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startingPrice">
              <th scope="col" mat-header-cell *matHeaderCellDef>Symbol</th>
              <td mat-cell *matCellDef="let element"
                class="column-4 listing-data-entry table-with-row-header yellow-bg">
                <span class="td-header">Starting Price</span>
                <input class="form-control" type="number" [id]="element?.lotNumber" min="0" [max]="bidMaxAmount"
                  [value]="element?.openingPrice" (change)="changePrices(element, $event.target.value, false)" />
              </td>
            </ng-container>

            <ng-container matColumnDef="reservePrice">
              <th scope="col" mat-header-cell *matHeaderCellDef>
                Reserve Price
              </th>
              <td mat-cell *matCellDef="let element" class="column-5 listing-data-entry table-with-row-header">
                <ng-container *ngIf="element.lotType == 1">
                  <span class="td-header">Reserve Price</span>
                  <input class="form-control" type="number" [id]="element?.lotNumber" min="0" [max]="bidMaxAmount"
                    [value]="element?.reservePrice" [disabled]="element.addedInBulkLotId"
                    (change)="changePrices(element, $event.target.value, true)" />
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="lotEndTime">
              <th scope="col" mat-header-cell *matHeaderCellDef>Symbol</th>
              <td mat-cell *matCellDef="let element"
                class="column-6 listing-data-entry table-with-row-header yellow-bg">
                <span class="td-header">Lot End Time</span>
                {{
                element?.lotEndTime
                | toLocalDateTime: false:element?.timeZoneName
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="currentBid">
              <th scope="col" mat-header-cell *matHeaderCellDef>Symbol</th>
              <td mat-cell *matCellDef="let element" class="column-7 listing-data-entry table-with-row-header">
                <span class="td-header">Current Bid</span>
                {{
                element?.currentBid == null
                ? "-"
                : (element?.currentBid
                | auctionCurrency: auctionData?.currencyName)
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="isFeatured">
              <th scope="col" mat-header-cell *matHeaderCellDef>Featured</th>
              <td mat-cell *matCellDef="let element"
                class="column-8 listing-data-entry table-with-row-header yellow-bg">
                <ng-container *ngIf="element.lotType == 1">
                  <span class="td-header">Featured</span>
                  {{ element.isFeatured ? "Yes" : "No" }}
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="lotButtons">
              <th scope="col" mat-header-cell *matHeaderCellDef>Symbol</th>
              <td mat-cell *matCellDef="let element" class="column-10 listing-data-entry table-with-row-header">
                <ng-container *ngIf="element.lotType == 1">
                  <span class="td-header">Bulk Lot</span>
                  {{ element.addedInBulkLotName | isEmpty }}
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="lotAction">
              <th scope="col" mat-header-cell *matHeaderCellDef>Symbol</th>
              <td mat-cell *matCellDef="let element" class="column-11">
                <div class="for-icons">
                  <a *ngIf="!element.isBiddingPaused"
                    class="hover-icon pauseBiddingIcon mr-1 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
                    [matTooltip]="'Pause Bidding'" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
                    role="button" (click)="openPauseResumeModal(pauseResumeModal, element)"></a>

                  <a *ngIf="element.isBiddingPaused"
                    class="hover-icon resumeBiddingIcon mr-1 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
                    [matTooltip]="'Resume Bidding'" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
                    role="button" (click)="openPauseResumeModal(pauseResumeModal, element)"></a>

                  <a class="hover-icon edit-icon mr-1 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
                    [matTooltip]="'Edit'" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
                    role="button" (click)="openLotModal(addLotModal, element)"></a>

                  <p class="hover-icon custom-tooltip custom-tooltip2 m-0 delete-icon" #tooltip="matTooltip"
                    matTooltip="Delete" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
                    role="button" (click)="openModal(deleteModal, element)"></p>
                </div>

                <div class="custom-dropdown align-self-center">
                  <button class="no-bg-btn hover-icon" mat-icon-button [matMenuTriggerFor]="listingMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #listingMenu="matMenu">
                    <div class="custom-dropdown">
                      <button mat-menu-item [class]="
                          element?.images == null ||
                          element?.images?.length == 0
                            ? 'd-none'
                            : ''
                        " type="button" [title]="
                          element?.images == null ||
                          element?.images?.length == 0
                            ? 'No images added yet'
                            : ''
                        " [disabled]="
                          element?.images == null ||
                          element?.images?.length == 0
                        " imagePreview [thumbnailImages]="element?.thumbnailImages" [actualImages]="element?.images"
                        [header]="'Lot Images'" [lotData]="{
                          lotNumber: element?.lotNumber,
                          lotDesc: element?.lotDescription
                        }">
                        View Lot Images
                      </button>

                      <ng-container *ngIf="element.lotType == 1">
                        <button mat-menu-item type="button" role="button" (click)="markLotAsFeatured(element)">
                          {{ element.isFeatured ? "Unmark" : "Mark" }} Lot as
                          Featured
                        </button>
                        <ng-container *ngIf="!isAuctionClosing && isBulkLotPresent">
                          <button mat-menu-item *ngIf="!element.addedInBulkLotId" type="button" role="button" (click)="
                              addLotsExistingBulkModal(
                                addLotsExistingBulk,
                                element
                              )
                            ">
                            Add to Existing Bulk Lot
                          </button>
                        </ng-container>
                        <ng-container *ngIf="!isAuctionClosing">
                          <button mat-menu-item *ngIf="element.addedInBulkLotId" type="button" role="button"
                            (click)="removeLotFromBulkLot(element)">
                            Remove from Bulk Lot
                          </button>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="element.lotType == 2">
                        <button mat-menu-item type="button" role="button"
                          (click)="manageBulkLotsModal(manageBulkLots, element)">
                          Manage Lots
                        </button>
                      </ng-container>
                    </div>
                  </mat-menu>
                </div>
              </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div [ngClass]="{
              'disable-event': this.openingAndReservePriceArray.length > 0
            }">
            <p *ngIf="this.openingAndReservePriceArray.length > 0">
              You left with some changes, save them first please
            </p>
            <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
              (page)="onPageChange($event)" *ngIf="totalLots > pageSize">
            </app-paginator>
          </div>
        </div>
      </ng-template>

      <div class="lot-btns lot-step1-btns mt-3 sticky-actions-group">
        <button class="btn btn-white-border mr-2 mb-2 min-110" role="button" (click)="onCancel()"
          *ngIf="!isAdminViewLot">
          Cancel
        </button>
        <button class="btn btn-white-border mr-2 mb-2 min-110" role="button" (click)="goToStep(true)"
          *ngIf="!isAdminViewLot">
          Back
        </button>
        <button class="btn btn-colored mb-2" [disabled]="lotsData?.length == 0" role="button" (click)="publishLots()">
          Publish & Close
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body">
    <div class="delete-data">
      <img alt="delete" src="../assets/images/delete-icon.svg" class="delete-icon" />
      <h1 class="modal-inner-hdg mt-3 mb-0">Delete Lot</h1>
      <p class="des">{{ lotDeletedMessage }}</p>
      <div class="delete-btns">
        <button class="btn btn-text mr-3" role="button" (click)="modalRef.hide()">
          Cancel
        </button>

        <button class="btn btn-colored" role="button" (click)="onDelete(lotId)">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pauseResumeModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body">
    <div class="delete-data">
      <h1 class="modal-inner-hdg mt-3 mb-0">
        {{ selectedLotData.isBiddingPaused ? "Resume" : "Pause" }} Bidding
      </h1>
      <p class="des">
        Are you sure you want to
        {{ selectedLotData.isBiddingPaused ? "resume" : "pause" }} bidding on
        the lot #{{ selectedLotData.lotNumber }}?
      </p>
      <div class="delete-btns">
        <button class="btn btn-text mr-3" role="button" (click)="closeModal()">
          Cancel
        </button>

        <button class="btn btn-colored" role="button" (click)="pauseResumeBidding()">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addLotModal>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">
      {{ !currentSelectedLot ? "Add New" : "Update" }} Lot
    </h4>
    <button type="button" class="close pull-right circle-icon tr-0 p-0 m-0" aria-label="Close" role="button"
      (click)="closeModal()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body pt-0">
    <div class="list-filter-tabs manageLotTabs mb-3" [ngClass]="{
        'disable-event': !currentSelectedLot
      }">
      <button class="list-tab" [ngClass]="{
          active: lotAddEditActiveStep == 1
        }" role="button" (click)="switchLotAddEditSteps(1)">
        <span class="step-name">Lot Details</span>
      </button>

      <button class="list-tab" [ngClass]="{
          active: lotAddEditActiveStep == 2
        }" role="button" (click)="switchLotAddEditSteps(2)">
        <span class="step-name">Lot Images</span>
      </button>
    </div>

    <div *ngIf="lotAddEditActiveStep == 1">
      <app-lot-form [auctionId]="auctionId" [lotId]="currentSelectedLot?.id" [auctionData]="auctionData"
        (lotFormStep1Completed)="lotFormStepCompleted($event)" *ngIf="isIndividualLot">
        <!-- *IMP, do not remove the class closeModalButton, it is for content projection -->
        <button type="button" class="btn btn-white-border font-15 closeModalButton" role="button"
          (click)="closeModal()">
          Cancel
        </button>
      </app-lot-form>
      <app-bulk-lot-form [auctionId]="auctionId" [lotId]="currentSelectedLot?.id" [auctionData]="auctionData"
        (lotFormStep1Completed)="lotFormStepCompleted($event)" *ngIf="!isIndividualLot">
        <!-- *IMP, do not remove the class lotType, it is for content projection -->
        <div class="col-md-12 lotType" *ngIf="!currentSelectedLot">
          <div class="form-group mb-2">
            <label class="form-label">Lot Type</label>
            <div class="d-flex for-mobile-radio for-mobile-wrap">
              <div class="form-group custom-radio radio-green mr-4 pr-3 mb-1">
                <input type="radio" name="status" value="false" [checked]="!isIndividualLot"
                  (change)="switchModes($event)" id="1" />
                <label for="1">Bulk Lot</label>
              </div>
              <div class="form-group custom-radio radio-green mr-4 pr-3 mb-1">
                <input type="radio" name="status" value="true" [checked]="isIndividualLot"
                  (change)="switchModes($event)" id="2" />
                <label for="2">Individual Lot</label>
              </div>
            </div>
          </div>
        </div>
        <!-- *IMP, do not remove the class closeModalButton, it is for content projection -->
        <button type="button" class="btn btn-white-border font-15 closeModalButton" role="button"
          (click)="closeModal()">
          Cancel
        </button>
      </app-bulk-lot-form>
    </div>

    <div *ngIf="lotAddEditActiveStep == 2">
      <div class="row">
        <div class="col-12">
          <p class="small-label mb-3">Thumbnail Image</p>
          <p class="upload-note m-0 pb-2">
            image should be greater than 256 Pixel X 256 pixel
          </p>
          <div class="upload-with-name">
            <div class="custom-file-upload">
              <span class="upload-inner">
                <div *ngIf="thumbnailImageString != null; else showPlaceholder">
                  <img alt="thumb-image" class="thumb-image" width="150" [src]="thumbnailImageString" />
                </div>
                <ng-template #showPlaceholder>
                  <img class="thumb-image" src="../assets/images/thumbnail-square.jpg" title="thumb-image"
                    alt="thumb-image" />
                </ng-template>
                <img src="../assets/images/ic-upload-photo.svg" class="upload-btn" alt="upload-btn" role="button"
                  (click)="cover.click()" />
              </span>
              <input type="file" style="display: none" [accept]="lotImageFormat" #cover
                (change)="uploadThumbnailImage($event.target.files)" />
            </div>
            <div class="for-info">
              <p class="upload-note m-0">
                Recommended Size : <br class="d-sm-none" />
                1024 * 720 px <br />
                <br class="d-sm-none" />
                File size should not exceed
                {{ +lotImageSize / (1024 * 1024) }} MB
              </p>
              <control-messages [control]="thumbnailImageControl"></control-messages>
            </div>
          </div>
        </div>

        <div class="col-12">
          <p class="small-label mb-3">Lot Images</p>
          <p class="upload-note m-0 pb-2">
            image should be greater than 256 Pixel X 256 pixel
          </p>
          <image-uploader [lotId]="currentSelectedLot?.id" [imageSize]="+lotImageSize" [imageFormat]="lotImageFormat"
            [uploadedImages]="addEditLotImages" [orderChangeNeeded]="true"
            (resultantImages)="resultantLotImages = $event" [errorLogs]="errorLogs"></image-uploader>
        </div>
      </div>

      <div class="image-popup-wrap pt-2 mt-2">
        <button type="button" class="btn btn-white-border font-15 mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-colored font-15" [disabled]="loading" role="button"
          (click)="addEditLotStep2Submit()">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Save & Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #manageBulkLots>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">Manage Lots For Bulk Lot</h4>
    <button type="button" class="close pull-right circle-icon tr-0 p-0 m-0" aria-label="Close" role="button"
      (click)="closeModal()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body pt-1 plMob20">
    <div class="modalAlertWrapper">
      <div class="leftWrapAlert">
        <h4 class="name">Lot #</h4>
        <p class="des">{{ currentSelectedLot?.lotNumber }}</p>
      </div>
      <div class="rightWrapAlert">
        <h4 class="name">Lot Description</h4>
        <p class="des">{{ currentSelectedLot?.description }}</p>
      </div>
    </div>

    <div class="data-table-wrap w-100">
      <table aria-label="table" mat-table [dataSource]="allLotsOfBulkLot"
        class="mat-elevation-z8 w-100 table-with-border manageBulkLotsTable">
        <ng-container matColumnDef="lotNo">
          <th scope="col" mat-header-cell *matHeaderCellDef>Lot #</th>
          <td mat-cell *matCellDef="let element" class="column-1 listing-data-entry table-with-row-header">
            <span class="td-header">Lot #</span> {{ element.lotNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lotDes">
          <th scope="col" mat-header-cell *matHeaderCellDef>Lot Description</th>
          <td mat-cell *matCellDef="let element" class="column-2 listing-data-entry table-with-row-header yellow-bg">
            <span class="td-header">Lot Description</span>
            <p class="m-0 forPadText">{{ element.description }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="lotLocation">
          <th scope="col" mat-header-cell *matHeaderCellDef>Location</th>
          <td mat-cell *matCellDef="let element" class="column-3 listing-data-entry table-with-row-header">
            <span class="td-header">Location</span> {{ element.location }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lotAction">
          <th scope="col" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="column-4 listing-data-entry table-with-row-header">
            <span class="td-header"> </span>
            <div class="for-icons justify-content-end">
              <p class="hover-icon custom-tooltip custom-tooltip2 m-0 delete-icon" #tooltip="matTooltip"
                matTooltip="Delete" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'" role="button"
                (click)="openRemoveLotModal(removeLotFromBulkTemp, element)"></p>
            </div>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
      </table>
    </div>

    <div class="pt-3 text-center">
      <button type="button" class="btn btn-white-border font-15 mr-2 min-100" role="button" (click)="closeModal()">
        Close
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addLotsExistingBulk>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">Add Lot to Existing Bulk Lot</h4>
    <button type="button" class="close pull-right circle-icon tr-0 p-0 m-0" aria-label="Close" role="button"
      (click)="closeModal()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body pt-1 plMob20">
    <div class="modalAlertWrapper">
      <div class="leftWrapAlert">
        <h4 class="name">Lot #</h4>
        <p class="des">{{ currentSelectedLot?.lotNumber }}</p>
      </div>
      <div class="rightWrapAlert">
        <h4 class="name">Lot Description</h4>
        <p class="des">{{ currentSelectedLot?.description }}</p>
      </div>
    </div>

    <div class="data-table-wrap w-100">
      <table aria-label="table" mat-table [dataSource]="allBulkLots"
        class="mat-elevation-z8 w-100 table-with-border addLotsExistingBulkTable">
        <ng-container matColumnDef="lotNo">
          <th scope="col" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="column-1 listing-data-entry table-with-row-header">
            <div class="form-group custom-radio radio-green m-0">
              <input type="radio" name="status" id="lotRow" role="button" (click)="bulkLotToBeAddInLot = element" />
              <label for="lotRow" class="m-0">&nbsp;</label>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lotDes">
          <th scope="col" mat-header-cell *matHeaderCellDef>Lot #</th>
          <td mat-cell *matCellDef="let element" class="column-2 listing-data-entry table-with-row-header yellow-bg">
            <span class="td-header">Lot #</span> {{ element.lotNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lotLocation">
          <th scope="col" mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element" class="column-3 listing-data-entry table-with-row-header">
            <span class="td-header">Lot Description</span>
            <p class="m-0 forPadText">{{ element.description }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="lotAction">
          <th scope="col" mat-header-cell *matHeaderCellDef>Location</th>
          <td mat-cell *matCellDef="let element" class="column-4 listing-data-entry table-with-row-header yellow-bg">
            <span class="td-header">Location</span> {{ element.location }}
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>
      </table>
    </div>

    <p class="error-msg" *ngIf="!bulkLotToBeAddInLot && bulkLotToBeAddInLotSubmit">
      please select a bulk lot first
    </p>

    <div class="pt-3 pb-0 pb-md-3">
      <button type="button" class="btn btn-white-border font-15 mr-2 min-100" role="button" (click)="closeModal()">
        Cancel
      </button>
      <button type="submit" class="btn btn-colored font-15 min-130"
        [disabled]="!bulkLotToBeAddInLot && bulkLotToBeAddInLotSubmit" role="button" (click)="addBulkLotToLot()">
        Save & Add
      </button>
    </div>
  </div>
</ng-template>

<ng-template #removeLotFromBulkTemp>
  <div class="red-alert modal-body text-center">
    <p>
      Are you sure you want to remove lot #{{ removingLotInfo?.lotNumber }} from
      Bulk Bid Lot #{{ currentSelectedLot?.lotNumber }}?
    </p>
    <button type="button" class="btn btn-sm btn-colored font-15 min-130 mr-2" role="button"
      (click)="removeLotFromBulkLot(removingLotInfo, true)">
      Ok
    </button>
    <button type="button" class="btn btn-sm btn-white-border font-15 min-100" role="button"
      (click)="removeLotModalRef.hide()">
      Cancel
    </button>
  </div>
</ng-template>
